'use es6';

import { SFDC_GET_INTEGRATION_STATUS } from 'DesignData/actions/ActionTypes';
import * as sfdcIntegrationStatusClient from 'DesignData/api/SalesforceIntegrationStatus';
import { getSalesforceIntegrationStatus } from 'DesignData/selectors/salesforceIntegrationStatus';
export function fetch() {
  const {
    request,
    receive,
    error
  } = fetch;
  return (dispatch, getState) => {
    const integrationStatus = getSalesforceIntegrationStatus(getState());
    if (integrationStatus !== null) return;
    dispatch(request());
    sfdcIntegrationStatusClient.fetch().then(status => {
      dispatch(receive(status));
    }).catch(__error => {
      dispatch(error(__error));
    });
  };
}

fetch.request = () => {
  return {
    type: SFDC_GET_INTEGRATION_STATUS
  };
};

fetch.receive = status => {
  return {
    type: SFDC_GET_INTEGRATION_STATUS,
    status
  };
};

fetch.error = error => {
  return {
    type: SFDC_GET_INTEGRATION_STATUS,
    error
  };
};